var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 0C9.85 0 0 9.85 0 22C0 34.15 9.85 44 22 44C34.15 44 44 34.15 44 22C44 9.85 34.15 0 22 0ZM31.536 18.28C31.7116 18.0793 31.8453 17.8455 31.9292 17.5923C32.0131 17.3392 32.0455 17.0718 32.0245 16.806C32.0036 16.5401 31.9297 16.2811 31.8072 16.0443C31.6846 15.8074 31.516 15.5974 31.3111 15.4267C31.1062 15.256 30.8693 15.1279 30.6142 15.0501C30.3591 14.9723 30.091 14.9463 29.8258 14.9737C29.5605 15.001 29.3034 15.0811 29.0695 15.2093C28.8356 15.3374 28.6298 15.5111 28.464 15.72L19.864 26.038L15.414 21.586C15.0368 21.2217 14.5316 21.0201 14.0072 21.0247C13.4828 21.0292 12.9812 21.2395 12.6104 21.6104C12.2395 21.9812 12.0292 22.4828 12.0247 23.0072C12.0201 23.5316 12.2217 24.0368 12.586 24.414L18.586 30.414C18.7825 30.6104 19.0178 30.7637 19.2768 30.8641C19.5359 30.9645 19.813 31.0099 20.0905 30.9973C20.3681 30.9847 20.64 30.9144 20.8888 30.7909C21.1377 30.6674 21.3581 30.4934 21.536 30.28L31.536 18.28Z",
    fill: "#5DB617"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmCheck);
export default __webpack_public_path__ + "static/media/confirm-check.5d82b475f9b6119943018bf7b7bf5039.svg";
export { ForwardRef as ReactComponent };